import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'
import { IPayload } from '@network/models/global.model'
import {
  IVaccinationType,
  IGetVaccinationTypesParams,
} from '@network/models/vaccination-type.model'

export class VaccinationTypesApi {
  constructor(private axios: AxiosService) {}

  getVaccinationTypes = async (params?: IGetVaccinationTypesParams) => {
    const response = await this.axios.get<IPayload<IVaccinationType[]>>(
      Endpoints.getVaccinationTypes,
      params,
    )
    return response
  }
}
